import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import {validToken} from "../helpers/helperJWT";
import {useSelector} from "react-redux";

function PrivateRoute({ component: Component, roles, ...rest }) {

    const authState = useSelector(state => state?.auth);

    return (
        <Route {...rest} render={props => {

            const infoToken = validToken(authState?.token);
            const {error} = infoToken;

            if(error){
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            }

            return <Component {...props} />

        }} />
    );
}

export { PrivateRoute };
